import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'cartaoDestino'
})
export class CartaoDestinoPipe implements PipeTransform {

  transform(cartao: any, args?: any): any {
    if (cartao !== undefined && cartao !== null) {
      return 'Nome: ' + cartao.nome + '  Cartão: ' + cartao.numero;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/resources/pipes/cartao-destino.pipe.ts